import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import React from 'react';
import { formatDate } from "../../utils";

const dateHelp = (content, title) => React.createElement(
    Tooltip,
    { title },
    React.createElement('span', null, content)
);

const deadlineHelp = (content) => dateHelp(content, "The estimated date for the delivery to be completed.");

export const EnquiryColumns = [
    {
        title: 'Project Id',
        dataIndex: 'id',
        key: 'id',
        // render : (id) => id
    },
    {
        title: 'Item',
        dataIndex: 'project_item',
        key: 'name',
        render : (project_item) => project_item?.product?.name

    },
    {
        title: dateHelp(React.createElement(React.Fragment, null, 'Request Date ', React.createElement(InfoCircleOutlined)), "The date the quotation request was created."),
        dataIndex: 'createdAt',
        key: 'createdAt',
        render : (createdAt) => dateHelp(formatDate(createdAt), "The date the quotation request was created.")

    },
    {
        title: deadlineHelp(React.createElement(React.Fragment, null, 'Deadline Delivery ', React.createElement(InfoCircleOutlined))),
        dataIndex: 'project_item',
        key: 'deadline',
        render : (project_item) => deadlineHelp(formatDate(project_item?.client_expected_delivery_date))

    },
];

// <div className={styles.box}>
//     <div className={styles.enquiryHeader}>
//         <h3>Open Enquiries</h3>
//     </div>
//    {enquiries.length!=0?
//     <table className={styles.tableSpacing}>
//     <tbody>
//         <tr >
//             <td className={styles.tableRow}>Project Id</td>
//             <td className={styles.tableRow}>Item</td>
//             {/* <td className={styles.tableRow}>Quantity</td> */}
//             <td className={styles.tableRow}>Request Date</td>
//             <td className={styles.tableRow}>Deadline Delivery</td>
//         </tr>

//         {enquiries.map((data) => {
//             return (
//                 <tr key={data.id} onClick={() => { navigate(`/quotation/${data.id}`) }}>
//                     <td className={styles.tableRow}>{data?.project_item?.project_id}</td>
//                     <td className={styles.tableRow}>{data?.project_item?.product?.name}</td>
//                     {/* <td className={styles.tableRow}>{data.quantity}</td> */}
//                     <td className={styles.tableRow}>{formatDate(data?.createdAt)}</td>
//                     <td className={styles.tableRow}>{formatDate(data?.project_item?.delivery_date)}</td>
//                 </tr>
//             )
//         })}
//         <tr className={styles.blank_row}>
//         <a className={styles.tfoot} onClick={() => { navigate('/quotation') }} >See More</a>
//         </tr>
//     </tbody>
